import script from "./StorySplit.vue?vue&type=script&lang=ts"
export * from "./StorySplit.vue?vue&type=script&lang=ts"

import "./StorySplit.vue?vue&type=style&index=0&id=37ebe048&lang=postcss"

export default script